<div class="pre-landing">
    <div class="title-container">
        <h2 class="title">Prenotazione Eventi</h2>
    </div>
    <div class="sub-title-container">
        <h4>Pannello di Amministrazione</h4>
    </div>
    <div class="image-container">
        <img src="/assets/img/calendario.png" alt="calendar" />
    </div>
    <div class="sub-title-container" >
        <h4 [hidden]="!wrongInput">Attenzione: dati di accesso errati</h4>
    </div>
    <div class="btn-container">
        <button class="btn-submit" (click)="login()">Entra</button>
    </div>
</div>